import PropTypes from "prop-types";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import validator from "validator";

import Modal from "../Modal";
import { SubmitButton } from "@/components/common/SubmitButton";

class CategoryEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category_id: 0,
      category_name: "",
      sort: "",
      timestamp: "",
      error: {},
      loading: false,
    };

    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeSort = this.handleChangeSort.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  componentDidMount() {
    this.props.setUnloadAlert();
  }

  componentWillUnmount() {
    this.props.clearUnloadAlert();
  }

  // eslint-disable-next-line react/no-deprecated -- 暫定処置でdisableしている
  componentWillReceiveProps(nextProps) {
    const data = nextProps.data;

    if (data) {
      const { category_id, category_name, sort, timestamp } = data;

      this.setState({
        category_id,
        category_name,
        sort,
        timestamp,
        loading: false,
        error: {},
      });
    } else {
      this.setState({
        category_id: 0,
        category_name: "",
        sort: "",
        timestamp: "",
        loading: false,
        error: {},
      });
    }
  }

  handleChangeName(e) {
    this.setState({
      category_name: e.target.value,
    });
  }

  handleChangeSort(e) {
    this.setState({
      sort: e.target.value,
    });
  }

  handleSave() {
    if (this.state.loading) return;
    const error = {};
    const category_name = this.state.category_name ? this.state.category_name.trim() : "";
    const newState = { ...this.state, category_name };

    if (validator.isEmpty(category_name)) {
      error.category_name = "category_name";
      error.msg = "is_required";
    } else if (category_name.length > 100) {
      error.category_name = "category_name";
      error.msg = "is_too_long";
    }

    if (!validator.isInt(this.state.sort.toString())) {
      error.sort = "display_order_is_invalid";
    } else if (this.state.sort > 999999999) {
      error.sort = "display_order_maximum";
    } else if (this.state.sort < 0) {
      error.sort = "display_order_negative";
    } else if (this.state.sort.toString().match(/^-0+$/)) {
      newState.sort = 0;
    } else {
      newState.sort = parseInt(this.state.sort, 10);
    }

    newState.error = error;

    if (Object.keys(error).length > 0) {
      this.setState(newState);
    } else {
      newState.loading = true;
      this.setState(newState);
      this.props.saveHandler(
        newState,
        () => this.setState({ loading: false }),
        () => this.setState({ loading: false })
      );
    }
  }

  render() {
    const { category_name, sort, error, loading } = this.state;
    const { fetching, closeHandler, t } = this.props;

    return (
      <Modal
        title={t("category_dialog_title")}
        loading={fetching}
        closeHandler={closeHandler}
        closeButtonDataTestId="master-category-button-close"
      >
        <div className="modal-body">
          <div className="form-row">
            <div className="form-group w-400">
              <span className="form-label txt-bold">{t("category_name")}</span>
              <input
                data-test-id="master-category-name"
                type="text"
                className="form-control w-290"
                value={category_name}
                onChange={this.handleChangeName}
              />
            </div>
            {error.category_name && (
              <div className="form-error w-400">
                <p className="form-error-message w-290">
                  {t(error.category_name)}
                  {t(error.msg)}
                </p>
              </div>
            )}
          </div>
          <div className="form-row">
            <div className="form-group w-230">
              <span className="form-label txt-bold">{t("display_order")}</span>
              <input
                data-test-id="master-category-sort"
                type="number"
                min="0"
                className="form-control w-120"
                value={sort}
                onChange={this.handleChangeSort}
              />
            </div>
            {error.sort && (
              <div className="form-error w-400">
                <p className="form-error-message w-290">{t(error.sort)}</p>
              </div>
            )}
          </div>
        </div>
        <div className={"modal-footer"}>
          <button
            data-test-id="master-category-button-cancel"
            type="button"
            className="btn btn-gray"
            disabled={loading}
            onClick={closeHandler}
          >
            {t("cancel")}
          </button>
          <SubmitButton data-test-id="master-category-button-save" onClick={this.handleSave} loading={loading} />
        </div>
      </Modal>
    );
  }
}

CategoryEditor.defaultProps = {
  data: null,
};

CategoryEditor.propTypes = {
  data: PropTypes.object,
  fetching: PropTypes.bool.isRequired,
  closeHandler: PropTypes.func.isRequired,
  saveHandler: PropTypes.func.isRequired,
  setUnloadAlert: PropTypes.func.isRequired,
  clearUnloadAlert: PropTypes.func.isRequired,
};

export default withTranslation()(CategoryEditor);
